import { useState } from "react";

export const useWidgetInfo = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [sections, setSections] = useState([]);
    const [sectionTitle, setSectionTitle] = useState('');

    const handleClose = () => {
        setIsOpen(false);
        setTitle('');
        setSections([]);
        setSectionTitle('');
    }

    const handleOpen = (title, sectionTitle, sections) => {
        setTitle(title);
        setSections(sections);
        setIsOpen(true);
        setSectionTitle(sectionTitle);
    }

    return { isOpen, setIsOpen, title, setTitle, sectionTitle, setSectionTitle, sections, setSections, handleClose, handleOpen };
}
